module.exports = __webpack_public_path__ + "media/new/approve_step_2-f9c0f608.png";